import React from 'react';

import { StyledBlogCard } from './styles';
import { HoverScaleImage } from '../../../components/atoms/hover-scale-image';
import { TagRounded } from '../../../components/atoms/tag-rounded';
import { IconTextLinkRounded } from '../../../components/molecules/icon-text-link-rounded';
import { Paragraph7 } from '../../../theme';
import { bemClassName } from '../../../utils/bem';

const b = bemClassName('blog-card');

const BlogCard = ({ image, tags, text, icon, iconText, iconTextLink, iconAriaLabel }) => {
  return (
    <StyledBlogCard $hasImage={!!image}>
      <div className={b()}>
        {image && (
          <div className={b('image')}>
            <HoverScaleImage source={image} />
          </div>
        )}
        <div className={b('content')}>
          <div className={b('content', 'tags')}>
            {tags.map((tag, index) => (
              <div key={`blog-card-tag-${index}`} className={b('content', 'tags', 'item')}>
                <TagRounded text={tag} />
              </div>
            ))}
          </div>
          <div className={b('content', 'title')}>
            <Paragraph7>{text}</Paragraph7>
          </div>
        </div>
        <div className={b('action')}>
          <IconTextLinkRounded
            icon={icon}
            text={iconText}
            link={iconTextLink}
            iconSize={32}
            ariaLabel={iconAriaLabel}
          />
        </div>
      </div>
    </StyledBlogCard>
  );
};

export default BlogCard;
